import type { Consultant } from "./Consultant";

export enum TabItemStatus {
	Completed = "completed",
	Todo = "todo",
}

export enum DateStatus {
	WeekDate = "weekDate",
	WeekEndDate = "weekEndDate",
	DisabledDate = "disabledDate",
	SelectedDate = "selectedDate",
}

export interface ScheduleWeekItem {
	weekNumber: string;
	dateList: ShiftItem[];
}

export interface SelectOption {
	key: string;
	value: string;
}

export interface ConsultantSelectTypeOption {
	keyValue: BookingType;
	label: string;
	description: string;
}

export interface MenuData {
	selectedConsultants: Consultant[];
	shouldSystemChooseIfSelectedConsultantsNotAvailable: boolean | null;
}

export interface VisitingAddress {
	address1?: string;
	address2?: string;
	postalCode?: string;
	city?: string;
	country?: string;
}

export interface ProfileAddress {
	address1?: string;
	postalCode?: string;
	city?: string;
}

export interface ShiftItem {
	start: string;
	end: string;
	break?: number;
	flexible?: boolean;
	id?: string;
	hasWorked?: boolean;
	isExpanded?: boolean;
	tempStatus?: "BOOKED_WITH_CONSULTANT" | "BOOKED_WITHOUT_CONSULTANT" | "TEMPORARY_ADDED" | "DEFAULT";
	status?: "EXTEND_REQUESTED" | "EXTEND_DECLINED" | "EXTEND_ACCEPTED";
}

export interface AvailabilityItem {
	end: string;
	start: string;
}

export interface Competence {
	branch: string;
	service: string;
	skills?: string[];
}

export interface Profile {
	profilePicture?: string;
	availability?: {
		sunday: AvailabilityItem[];
		monday: AvailabilityItem[];
		tuesday: AvailabilityItem[];
		wednesday: AvailabilityItem[];
		thursday: AvailabilityItem[];
		friday: AvailabilityItem[];
		saturday: AvailabilityItem[];
	};
	presentation?: string;
	address?: ProfileAddress;
	employeeNumber?: number;
	phoneNumber?: string;
	documents?: Documents;
}

export interface Documents {
	VOCATIONAL_IDENTIFICATION?: {
		[k: string]: unknown;
	};
	POLICE_RECORD_EXTRACTS?: {
		[k: string]: unknown;
	};
	DRIVING_LICENCE?: {
		[k: string]: unknown;
	};
}

export interface ContactPerson {
	id: string;
	firstName?: string;
	lastName?: string;
	email?: string;
	profile?: Profile;
}

export interface CreateOrder {
	// step one data
	address?: VisitingAddress;
	competence: Competence;
	customerDescription?: string;
	description?: string;
	contactPersons?: ContactPerson[];
	//step two data
	shifts: ShiftItem[];
	// step 3 data
	allowLaterBooking?: boolean;
	bookingType: "OPEN" | "INVITATION" | "AUTO";
	customer: { id: string };
	invitations?: string[];
	numPositions: number;
}

export interface StepOneData {
	address?: VisitingAddress;
	competence: Competence;
	customerDescription?: string;
	description?: string;
	contactPersons?: ContactPerson[];
	images?: FileData[];
	documents?: FileData[];
}

export interface StepTwoData {
	shifts: ShiftItem[];
}

export enum BookingType {
	OPEN = "OPEN",
	INVITATION = "INVITATION",
}

export interface StepThreeData {
	bookingType: BookingType;
	customer: { id: string };
	numPositions: number;
	allowLaterBooking?: boolean;
	invitations?: string[];
	internalNotes?: string | undefined;
}

export interface MinStartDateComparison {
	startWeekNumber: number;
	isFutureMinimumDate: boolean;
	year: string;
}

export interface FileData {
	url: string;
	name: string;
}
